
export const CUSTOMER_LOADING = 'REDUX_SAGA_CUSTOMER_LOADING';
export const CUSTOMER_SUCCESS = 'REDUX_SAGA_CUSTOMER_SUCCESS';
export const CUSTOMER_ERROR = 'REDUX_SAGA_CUSTOMER_ERROR';
export const RESET_CUSTOMER = 'REDUX_SAGA_RESET_CUSTOMER';

export const actionGetCustomer = (dispatch, customerId, cstemail) => {
    dispatch({ type: CUSTOMER_LOADING, customerId: customerId, cstemail: cstemail });
};

export const actionResetCustomer = (dispatch) => {
    dispatch({ type: RESET_CUSTOMER })
};
